module.exports = __webpack_public_path__ + "img/tu_schedule_travel.ab7f4266.svg";